import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages/insert-block';
import {
	QuickInsertMenuItem,
	type OnSelectContext,
} from '@atlaskit/editor-common/quick-insert/menu-item';
import { useQuickInsertContext } from '@atlaskit/editor-common/quick-insert/use-quick-insert-context';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import AiSparkleIcon from '@atlaskit/icon/core/ai-sparkle';

import type { AIImageGenerationPlugin } from '../../aiImageGenerationPluginType';

export const AIImageGenerationQuickInsertMenuItem = ({
	api,
}: {
	api: ExtractInjectionAPI<AIImageGenerationPlugin> | undefined;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { isOffline } = useQuickInsertContext();
	const title = formatMessage(messages.aiImageGeneration);
	const onSelect = useCallback(
		({ insert }: OnSelectContext) => {
			const tr = insert('');
			api?.aiImageGeneration.commands.showAIImageGenerationPopup()({ tr });
			return tr;
		},
		[api],
	);

	return (
		<QuickInsertMenuItem
			iconBefore={<AiSparkleIcon label={title} color="currentColor" />}
			isDisabled={isOffline}
			onSelect={onSelect}
			title={title}
		/>
	);
};
